export const SET_PAID = "payment/SET_PAID"
export const SET_SAVED = "payment/SET_SAVED"
export const SET_INTEGRATION = "payment/SET_INTEGRATION"
export const SET_REENTRY = "payment/SET_REENTRY"
export const SET_TIMED_OUT = "payment/SET_TIMED_OUT"
export const SET_TIPPED = 'payment/SET_TIPPED'
export const SET_DISABLE_TIP = 'payment/SET_DISABLE_TIP'
export const SET_TIP_ERROR_MSG = 'payment/SET_TIP_ERROR_MSG'
export const SET_PAYMENT_ERROR_MSG = 'payment/SET_PAYMENT_ERROR_MSG'
export const SHOW_TELEMEDICINE_MODAL = 'payment/SHOW_TELEMEDICINE_MODAL'


// WEBPACK FOOTER //
// ./assets/payment/actionTypes.js